import Vue from "vue";
import App from "@/App.vue";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import VueCompositionAPI from "@vue/composition-api";
import VueLodash from "vue-lodash";
import find from "lodash/find";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import orderBy from "lodash/orderBy";
import { db } from "@/firebase/firebase";
//@ts-ignore
import VueHtmlToPaper from 'vue-html-to-paper';


// @ts-ignore
import ImageUploader from "vue-image-upload-resize";
//@ts-ignore
import VueChatScroll from "vue-chat-scroll";
import { firestorePlugin } from "vuefire";


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
    'https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css',
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
  ]
}
Vue.use(VueHtmlToPaper, options);
Vue.use(firestorePlugin);
Vue.use(ImageUploader);
Vue.use(VueChatScroll);
Vue.use(VueCompositionAPI);
Vue.use(VueLodash, { lodash: { filter, find, sortBy, orderBy } });

Vue.prototype.$db = db;

// import { Vue2Storage } from "vue2-storage";
// Vue.use(Vue2Storage);

// import 'vue-croppa/dist/vue-croppa.css'
// import Croppa from 'vue-croppa'
// Vue.use(Croppa)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
